<template>
  <div class="div1">
    <mu-appbar style="width: 100%;height:40px;" color="primary">
      <span style="font-size: 14px;"> <mu-chip class="demo-chip" color="blue200" delete @delete="logout" style="height:22px; vertical-align:middle;">
          <mu-icon value="person"/><span style="font-size: 10px;">{{username}}</span>
        </mu-chip></span>
    </mu-appbar>
    <div class="div11">
      <mu-container class="mu-container">
        <mu-button color="green" @click="idus_in_stock">入库操作</mu-button>
        <mu-button color="green" @click="s_in_stock">入库查询</mu-button>
        <br>
        <mu-button color="blue" @click="idus_stock">库存操作</mu-button>
        <mu-button color="blue" @click="s_stock">库存查询</mu-button>
        <br>
        <mu-button color="red" @click="idus_out_stock">出库操作</mu-button>
        <mu-button color="red" @click="s_out_stock">出库查询</mu-button>
      </mu-container>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import Qs from 'qs'
  import Toast from 'muse-ui-toast';
  import { Dialog } from 'vant';

  export default {
    created: function () {
      let _this = this;

      this.$progress.start();

      function init() {
        var p = new Promise(function (resolve, reject) {
          axios.post('/stock/in_stock_type_all.mvc', Qs.stringify({}))
            .then(function (response) {
              //console.log("select.mvc response = "+JSON.stringify(response));
              if (response.data.status == "0") {
                Toast.error('没有数据！');
              }
              if (response.data.status == "2") {
                Toast.error('查询异常！');
              }
              if (response.data.status == "3") {
                Toast.error('请重新登录');
                Dialog.alert({
                  title: '请重新登录',
                  message: ''
                }).then(() => {
                  _this.$router.replace("/Login");
                });
              }
              if (response.data.status == "1") {
                // console.log("select.mvc response = "+JSON.stringify(response.data.data));
                //console.log("init2");
                _this.STORE.in_stock_type_all = response.data.data;
                resolve();
              }
            })
            .catch(function (error) {
              console.log(error);
            })
        });
        return p;
      }

      Promise
        .all([
          init()
        ])
        .then(function (results) {
          _this.$progress.done();
        });
    },
    data () {
      return {
        username : this.STORE.login.name
      }
    },
    methods: {
      logout() {
        let _this = this;
        let loading = _this.$loading();

        axios.post('/stock/logout.mvc', Qs.stringify({
          name: _this.STORE.login.name
        }))
          .then(function (response) {
            loading.close();
            console.log(response);
            if(response.data == "1"){
              _this.STORE.login.name = "";
              _this.$router.replace("/Login");
            }
          })
          .catch(function (error) {
            _this.STORE.login.name = "";
            loading.close();
            console.log(error);
          })
      },
      idus_in_stock () {
        this.$router.replace("/Idus_in_stock");
      },
      s_in_stock () {
        this.$router.replace("/S_in_stock");
      },
      idus_out_stock () {
        this.$router.replace("/Idus_out_stock");
      },
      s_out_stock () {
        this.$router.replace("/S_out_stock");
      },
      s_stock () {
        this.$router.replace("/S_stock");
      },
      idus_stock () {
        this.$router.replace("/Idus_stock");
      }
    }
  };
</script>
<style>
  .mu-paper .mu-expansion-panel-header {
    padding: 0 10px;
  }
  .mu-paper .mu-icon-button {
    width: 36px;
    height: 36px;
  }
  .mu-paper  .mu-expansion-panel-content {
    padding: 0 10px 10px;
    line-height: 1.4;
  }
</style>
<style scoped>
  .div11{
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 80vh;
  }
  .mu-button{
    width:100px;
    font-size: 16px;
    margin: 10px;
  }
  .mu-container{
    min-width:250px;
    width:300px;
    text-align: center;
  }

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/home/Home.vue